import { memo } from 'react'

import * as MdIcons from 'react-icons/md'
import { useParams, useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { Tile } from '@components/Tile'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'

interface IMidstreamTile {
  task: IGenericTask
}

export const MidstreamTile = memo(function MidstreamTile({
  task,
}: IMidstreamTile) {
  const theme = useTheme()

  const navigate = useNavigate()

  function handleTilePress(taskId: number) {
    navigate(`/task/${taskId}`)
  }

  return (
    <Tile.Provider isSelectEnabled={true} isSelectable={false}>
      <Tile.Root
        tileBackground={theme.colors.tileForeground}
        onPress={() => handleTilePress(task.id)}
        onSelection={() => {}}
      >
        <Tile.StatusPill isTeco={!!task.sapActionsType} status={task.status} />
        <Tile.Checkbox />
        <Tile.Container>
          <Tile.Header>
            <Tile.Title>{task.name}</Tile.Title>
          </Tile.Header>

          <Tile.Body>
            <Tile.Value>{task.code}</Tile.Value>
            <Tile.Row>
              <Tile.Label>Area</Tile.Label>
              <Tile.Value>{task.area?.code}</Tile.Value>
            </Tile.Row>
            <Tile.Row>
              <Tile.Label>Location</Tile.Label>
              {typeof task.location === 'object' && (
                <Tile.Value>{task.location?.description}</Tile.Value>
              )}
            </Tile.Row>
            <Tile.Row>
              <Tile.Label>Equipment Description</Tile.Label>
              <Tile.Value>{task.equipmentDescription}</Tile.Value>
            </Tile.Row>
            <Tile.Row>
              <Tile.Label>Equipment</Tile.Label>
              <Tile.Value>{task.equipmentTag}</Tile.Value>
            </Tile.Row>
          </Tile.Body>

          <Tile.Footer.Container>
            {task.jobAbcIndicator && (
              <Tile.Footer.Box>
                <MdIcons.MdAbc size={24} color={theme.colors.info} />
                <Tile.Label>{task.jobAbcIndicator}</Tile.Label>
              </Tile.Footer.Box>
            )}
            {task.hasBarrier && (
              <MdIcons.MdFence
                size={24}
                color={theme.colors.hasBarrier}
              />
            )}
          </Tile.Footer.Container>
        </Tile.Container>
      </Tile.Root>
    </Tile.Provider>
  )
})
